<div mat-dialog-title>
  <div class="row">
    <div class="col-sm-6">
      <mat-label class="dialog-title">{{ 'DIALOGS.BREAK_IN_OUT_TITLE' | translate }}</mat-label>
    </div>
    <div class="col-sm-6 right-aligned" style="align-items: center; display: flex; justify-content: flex-end;">
      <mat-icon (click)="onCancel()">close</mat-icon>
    </div>
  </div>
</div>
<mat-dialog-content>
  <mat-label>{{ message }}</mat-label>
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>{{ 'DIALOGS.DESCRIPTION_LABEL' | translate }}</mat-label>
    <textarea
      matInput
      [attr.maxlength]="maxCommentLength"
      [formControl]="descriptionFormControl"
    ></textarea>
  </mat-form-field>
  <div class="char-count" [class.char-count--over]="(descriptionFormControl.value?.length || 0) > maxCommentLength">
    {{ descriptionFormControl.value?.length || 0 }} / {{ maxCommentLength }}
  </div>
  <ng-container *ngIf="allowAttachment">
    <p class="attach-text">{{ 'DIALOGS.OR_ATTACH_FILE' | translate }}</p>
    <input #fileInput type="file" (change)="onFileSelected($event)" style="display:none" />
    <button mat-stroked-button type="button" (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon>
      {{ 'DIALOGS.CHOOSE_FILE' | translate }}
    </button>
    <span *ngIf="selectedFile" class="selected-file-name">
      {{ selectedFile.name }}
      <mat-icon class="remove-file-icon" (click)="onRemoveFile()">close</mat-icon>
    </span>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="submit" (click)="onConfirm()">
    {{ actionName }}
  </button>
  <button mat-raised-button class="discard-changes" (click)="onCancel()">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
